<template>
  <div>
    <alert
      :visible="!!messageAlert"
      dark
      :type="typeAlert"
      :message="messageAlert"
      :clickClose="() => (messageAlert = '')"
    />
    <v-data-table
      :headers="headers"
      :loading="loading"
      :items="specialConditions"
      :search="search"
      sort-by="provider"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title
            >CONDIÇÃO DE PAGAMENTO ESPECIAL - FRANQUIAS</v-toolbar-title
          >
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Busca"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" dark @click="newItem()">
            <v-icon>mdi-plus</v-icon>
            Novo
          </v-btn>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-toolbar color="red lighten-1" dark class="text-h5"
                >Atenção</v-toolbar
              >
              <v-card-title class="text-h6">
                Tem certeza que deseja Deletar?
              </v-card-title>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete()"
                  >Fechar</v-btn
                >
                <v-btn
                  color="red darken-1"
                  dark
                  @click="deletePaymentSpecialCondition()"
                >
                  <v-icon dark>mdi-delete</v-icon>
                  Deletar
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.actions="{ item }">
        <v-tooltip top color="blue darken-1">
          <!-- eslint-disable-next-line -->
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              color="blue darken-1"
              @click="editItem(item)"
              v-bind="attrs"
              v-on="on"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>Editar</span>
        </v-tooltip>
        <v-tooltip top color="error">
          <!-- eslint-disable-next-line -->
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="red darken-1"
              @click="deleteItem(item)"
              v-bind="attrs"
              v-on="on"
            >
              mdi-delete
            </v-icon>
          </template>
          <span>Deletar</span>
        </v-tooltip>
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.provider="{ item }">
        {{ item.provider.code }} - {{ item.provider.name }}
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.company="{ item }">
        {{ item.company.code }} - {{ item.company.name }}
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.payment_condition="{ item }">
        {{ item.payment.name }}
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.discount="{ item }">
        {{ item.discount }}%
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.start_date="{ item }">
        {{ item.start_date | dateFormatToBr }}
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.end_date="{ item }">
        {{ item.end_date | dateFormatToBr }}
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="getPaymentSpecialConditions()">
          Recarregar
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog v-model="dialogForm" hide-overlay persistent max-width="1300px">
      <v-card>
        <v-card-title>Condição de Pagamento Especial</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-4">
          <alert
            :visible="!!messageAlertDialog"
            dark
            :type="typeAlertDialog"
            :message="messageAlertDialog"
            :clickClose="() => (messageAlertDialog = '')"
          />
          <v-row>
            <v-col>
              <v-select
                :items="providers"
                :item-text="(item) => `${item.code} - ${item.name}`"
                item-value="id"
                v-model="editedItem.provider_id"
                label="Fornecedor"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col>
              <v-select
                :items="companies"
                :item-text="(item) => `${item.code} - ${item.name}`"
                item-value="id"
                v-model="editedItem.company_id"
                label="Franquia"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col>
              <v-select
                :items="paymentConditions"
                item-text="name"
                item-value="id"
                v-model="editedItem.payment_condition_id"
                label="Condição de Pagamento"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-mask="dateMask"
                outlined
                dense
                hide-details
                v-model="editedItem.start_date"
                label="Data Inicial"
                append-outer-icon="mdi-calendar"
                @click:append-outer="handlerCalendar('start_date')"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-mask="dateMask"
                outlined
                dense
                hide-details
                label="Data Final"
                v-model="editedItem.end_date"
                append-outer-icon="mdi-calendar"
                @click:append-outer="handlerCalendar('end_date')"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                outlined
                dense
                hide-details
                class="fs-12"
                label="Desconto"
                v-model.number="editedItem.discount"
                suffix="%"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closePromotionalDialog()">
            Fechar
          </v-btn>
          <v-btn
            color="green darken-3"
            class="white--text"
            @click="confirmSpecialDialog()"
          >
            <v-icon left>mdi-check</v-icon>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      ref="dialog"
      v-model="modalDate"
      :return-value.sync="dateDialog"
      width="290px"
    >
      <v-date-picker
        v-model="dateDialog"
        scrollable
        no-title
        @change="handlePickerDate"
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="modalDate = false"> Fechar </v-btn>
      </v-date-picker>
    </v-dialog>
  </div>
</template>

<script>
import { URL } from "@/api/config";

import * as CompanySpecialPaymentAPI from "@/api/requests/CompanySpecialPaymentRequest";
import * as CompanyAPI from "@/api/requests/CompanyRequest";

import Alert from "@/components/Alert";
import AwesomeMask from "awesome-mask";

export default {
  components: {
    Alert,
  },
  directives: {
    mask: AwesomeMask,
  },
  data: () => ({
    dateMask: "99/99/9999",
    dialogDelete: false,
    search: "",
    loading: false,
    headers: [
      { text: "Fornecedor", value: "providerFull", width: "20%" },
      { text: "Franquia", value: "companyFull", width: "20%" },
      {
        text: "Condição de Pagamento",
        value: "payment_conditionFull",
        width: "20%",
      },
      { text: "Desconto", value: "discount" },
      { text: "Data Inicial", value: "start_date" },
      { text: "Data Final", value: "end_date" },
      {
        text: "Ação",
        value: "actions",
        sortable: false,
        width: 100,
        align: "right",
      },
    ],
    specialConditions: [],
    companies: [],
    providers: [],
    editedItem: {
      id: "",
      provider_id: "",
      company_id: "",
      payment_condition_id: "",
      start_date: "",
      end_date: "",
      discount: "0",
    },
    defaultItem: {
      id: "",
      provider_id: "",
      company_id: "",
      payment_condition_id: "",
      start_date: "",
      end_date: "",
      discount: "0",
    },
    dialogForm: false,
    payments: [],
    paymentConditions: [],
    messageAlert: "",
    typeAlert: "",
    messageAlertDialog: "",
    typeAlertDialog: "",
    dateDialog: "",
    modalDate: false,
    fieldDate: "",
  }),
  filters: {
    dateFormatToBr(date) {
      if (date == "" || date === null) return "";
      return date.split("-").reverse().join("/");
    },
    dateFormatToEua(date) {
      if (date == "" || date === null) return "";
      return date.split("/").reverse().join("-");
    },
  },

  computed: {},

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      await this.getPaymentSpecialConditions(); // Main Table
      this.getProviders(); // Dialog
      this.getCompanies(); // Dialog
      this.getPaymentConditions(); // Dialog
    },
    async getProviders() {
      this.loading = true;
      this.providers = [];
      try {
        let data = await CompanyAPI.getAll("?type=for");
        this.providers = data.sort((a, b) => (a.code > b.code ? 1 : -1));
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async getCompanies() {
      this.loading = true;
      this.companies = [];
      try {
        let data = await CompanyAPI.getAll("?type=fra,mult");
        this.companies = data.sort((a, b) => (a.code > b.code ? 1 : -1));
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async getPaymentConditions() {
      this.loading = true;
      this.paymentConditions = [];
      try {
        let res = await fetch(`${URL}payment-condition`);
        let data = await res.json();
        this.paymentConditions = data.sort((a, b) =>
          a.name > b.name ? 1 : -1
        );
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    editItem(item) {
      this.editedItem = {
        ...item,
        start_date: this.dateFormatToBr(item.start_date),
        end_date: this.dateFormatToBr(item.end_date),
      };
      this.dialogForm = true;
    },
    deleteItem(item) {
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },
    async post(data) {
      this.loading = true;
      try {
        await CompanySpecialPaymentAPI.post(data);
        this.dialogForm = false;
        await this.getPaymentSpecialConditions();
        this.messageAlert = "Condição de Pagamento Especial Salva com Sucesso";
        this.typeAlert = "success";
      } catch (error) {
        console.log(error);
        this.messageAlert =
          "Não foi possível salvar a condição especial de pagamento: " +
          error.message;
        this.typeAlert = "error";
      } finally {
        this.loading = false;
      }
    },
    async put(id, data) {
      this.loading = true;
      try {
        await CompanySpecialPaymentAPI.update(id, data);
        this.dialogForm = false;
        await this.getPaymentSpecialConditions();
        this.messageAlert = "Condição de Pagamento Especial Salva com Sucesso";
        this.typeAlert = "success";
      } catch (error) {
        console.log(error);
        this.messageAlert =
          "Não foi possível salvar a condição especial de pagamento: " +
          error.message;
        this.typeAlert = "error";
      } finally {
        this.loading = false;
      }
    },
    async getPaymentSpecialConditions() {
      this.loading = true;
      this.specialConditions = [];
      try {
        let data = await CompanySpecialPaymentAPI.getAll();
        this.specialConditions = data
          .sort((a, b) => (a.provider.name > b.provider.name ? 1 : -1))
          .map((item) => ({
            ...item,
            providerFull:
              typeof item.provider.code !== "undefined"
                ? `${item.provider.code} - ${item.provider.name}`
                : "",
            companyFull:
              typeof item.company.code !== "undefined"
                ? `${item.company.code} - ${item.company.name}`
                : "",
            payment_conditionFull:
              typeof item.payment.id !== "undefined" ? item.payment.name : "",
          }));
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async deletePaymentSpecialCondition() {
      this.loading = true;
      this.specialConditions = [];
      try {
        await CompanySpecialPaymentAPI.destroy(this.editedItem.id);
        this.loading = false;
        this.getPaymentSpecialConditions();
        this.messageAlert =
          "Condição de Pagamento Especial Deletada com Sucesso";
        this.typeAlert = "success";
      } catch (error) {
        this.loading = false;
        console.log(error);
        this.messageAlert =
          "Não foi possível deletar a Condição Especial de Pagamento: " +
          error.message;
        this.typeAlert = "error";
      }
      this.closeDelete();
    },
    filterPaymentsEspecial(payments) {
      return payments.filter(
        (payment) =>
          this.specialConditions.find(
            (item) => item.payment_condition_id === payment.id
          ) === undefined
      );
    },
    handlerCalendar(field) {
      let date = this[field];
      this.dateDialog = this.dateFormatToEua(date);
      this.fieldDate = field;
      this.modalDate = true;
    },
    dateFormatToBr(date) {
      if (date == "" || date === null) return "";
      return date.split("-").reverse().join("/");
    },
    dateFormatToEua(date) {
      if (date == "" || date === null) return "";
      return date.split("/").reverse().join("-");
    },
    handlePickerDate() {
      this[this.fieldDate] = this.dateFormatToBr(this.dateDialog);
      this.fieldDate = "";
      this.dateDialog = "";
      this.modalDate = false;
    },
    closePromotionalDialog() {
      this.dialogForm = false;
    },
    confirmSpecialDialog() {
      if (this.validate()) {
        const data = {
          ...this.editedItem,
          start_date: this.dateFormatToEua(this.editedItem.start_date),
          end_date: this.dateFormatToEua(this.editedItem.end_date),
        };
        if (data.id == "") {
          this.post(data);
        } else {
          this.put(this.editedItem.id, data);
        }
      }
    },
    validate() {
      if (this.editedItem.provider_id == "") {
        this.messageAlertDialog = "Selecione um Fornecedor para poder Salvar";
        this.typeAlertDialog = "error";
        return false;
      }
      if (this.editedItem.company_id == "") {
        this.messageAlertDialog = "Selecione uma Franquia para poder Salvar";
        this.typeAlertDialog = "error";
        return false;
      }
      if (this.editedItem.payment_condition_id == "") {
        this.messageAlertDialog =
          "Selecione uma Condição de Pagamento para poder Salvar";
        this.typeAlertDialog = "error";
        return false;
      }
      // if (
      //   this.editedItem.discount == "" ||
      //   parseFloat(this.editedItem.discount) < 0
      // ) {
      //   this.messageAlertDialog =
      //     "Preencha um Desconto Válido para poder Salvar";
      //   this.typeAlertDialog = "error";
      //   return false;
      // }
      return true;
    },
    newItem() {
      this.clearItem();
      this.dialogForm = true;
    },
    clearItem() {
      this.editedItem = Object.assign({}, this.defaultItem);
    },
  },
};
</script>
